export const getMessageContent = (message) =>
  message?.content || message?.message || message?.text || message?.body || "";
